import { render, staticRenderFns } from "./FormInput.vue?vue&type=template&id=57513a32&"
import script from "./FormInput.vue?vue&type=script&lang=ts&"
export * from "./FormInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports